/*
 * This file is generated by generate_bundler_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {CreditCalculatorView} from "../../credit_calculator/views/CreditCalculatorView";
import {CreditOffersListView} from "../../credit_calculator/views/CreditOffersListView";
import {CreditRatingCalculatorView} from "../../credit_calculator/views/CreditRatingCalculatorView";
const route = [
    {bundlerEntry: "calculator", path: rpAppPath.credits.base, component: CreditCalculatorView},
    {bundlerEntry: "calculator", path: rpAppPath.credits.offers, component: CreditOffersListView},
    {bundlerEntry: "calculator", path: rpAppPath.credits.rating, component: CreditRatingCalculatorView}
];

(function () {
    rpClient(route);
})();
/*
 * This file is generated by generate_bundler_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {CreditCalculatorView} from "../../credit_calculator/views/CreditCalculatorView";
import {CreditOffersListView} from "../../credit_calculator/views/CreditOffersListView";
import {CreditRatingCalculatorView} from "../../credit_calculator/views/CreditRatingCalculatorView";
const route = [
    {bundlerEntry: "calculator", path: rpAppPath.credits.base, component: CreditCalculatorView},
    {bundlerEntry: "calculator", path: rpAppPath.credits.offers, component: CreditOffersListView},
    {bundlerEntry: "calculator", path: rpAppPath.credits.rating, component: CreditRatingCalculatorView}
];

(function () {
    rpClient(route);
})();
